import { Injectable } from "@angular/core";

import type { JwtPayload } from "@juristech/contracts/auth/jwt-payload.interface";

const ACCESS_TOKEN_KEY = "admin_access_token";

@Injectable({ providedIn: "root" })
export class TokenService {
  getAccessToken(): string | null {
    return sessionStorage.getItem(ACCESS_TOKEN_KEY);
  }

  setTokens(accessToken: string): void {
    sessionStorage.setItem(ACCESS_TOKEN_KEY, accessToken);
  }

  clearTokens(): void {
    sessionStorage.removeItem(ACCESS_TOKEN_KEY);
  }

  isTokenExpired(): boolean {
    const payload = this.decodeToken();
    if (!payload) return true;
    return Date.now() >= (payload.exp ?? 0) * 1000 - 30_000;
  }

  getTokenExpiryMs(): number | null {
    const payload = this.decodeToken();
    if (!payload?.exp) return null;
    return payload.exp * 1000 - Date.now();
  }

  decodeToken(): JwtPayload | null {
    const token = this.getAccessToken();
    if (!token) return null;
    try {
      const base64 = token.split(".")[1];
      const json = atob(base64.replace(/-/g, "+").replace(/_/g, "/"));
      return JSON.parse(json);
    } catch {
      return null;
    }
  }
}
